<script>
//耗材申请
import ApplyMaterial from '@/components/lottery/ApplyMaterial/index.vue';

export default {
  name:'logistics',
  data(){
    return{
      activeTab:0,
      showMaterial:false
    }
  },
  components:{
    ApplyMaterial
  },
  methods:{
    showPage(){

    },
    showToast(){

    },
    handleMaterial(data){
      console.log(data)
    },
    showModal(){
      this.showMaterial = !this.showMaterial;
    }
  },
  created(){

  }
}
</script>

<template>
  <!-- 物流查询页面 -->
  <div id="logisticsPage" class="">
    <apply-material v-model="showMaterial" @submit="handleMaterial" />
    <div class="content">
      <div class="tabs">
<!--        <div class="tab active" @click="switchTab(this, 'instantLottery')">即开票物流</div>-->
<!--        <div class="tab" @click="switchTab(this, 'equipmentLogistics')">设备物流</div>-->
<!--        <div class="tab" @click="switchTab(this, 'suppliesLogistics')">耗材物流</div>-->
        <van-tabs v-model="activeTab" animated swipeable sticky>
          <van-tab title="全部"></van-tab>
          <van-tab title="即开票物流"></van-tab>
          <van-tab title="耗材物流"></van-tab>
        </van-tabs>
      </div>
      <!--即开票物流标签页内容-->
      <div id="instantLottery" v-if="activeTab===1" class="tab-content">
        <div class="card">
          <div class="order-summary">
            <div class="order-icon">🎫</div>
            <div class="order-details">
              <div class="order-title">即开票物流跟踪</div>
              <div class="order-subtitle">订单编号: JK202503241856</div>
            </div>
          </div>

          <div class="card-info">
            <div class="info-label">发货时间</div>
            <div class="info-value">2025-03-22</div>
          </div>
          <div class="card-info">
            <div class="info-label">预计到达</div>
            <div class="info-value">2025-03-25</div>
          </div>
          <div class="card-info">
            <div class="info-label">当前状态</div>
            <div class="info-value">运输中</div>
          </div>

          <div class="divider"></div>

          <div class="timeline">
            <div class="timeline-item">
              <div class="timeline-time">2025-03-20 16:45</div>
              <div class="timeline-content">包裹已从成都市发出</div>
            </div>
            <div class="timeline-item">
              <div class="timeline-time">2025-03-20 10:22</div>
              <div class="timeline-content">福彩中心已发货</div>
            </div>
            <div class="timeline-item">
              <div class="timeline-time">2025-03-18 14:50</div>
              <div class="timeline-content">订单已确认</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 设备物流标签页内容 -->
      <div id="equipmentLogistics" v-else-if="activeTab===0" class="tab-content">
        <div class="card">
          <div class="order-summary">
            <div class="order-icon">🔧</div>
            <div class="order-details">
              <div class="order-title">物流跟踪</div>
              <div class="order-subtitle">订单编号: SB202503182245</div>
            </div>
          </div>

          <div class="card-info">
            <div class="info-label">设备类型</div>
            <div class="info-value">终端机</div>
          </div>
          <div class="card-info">
            <div class="info-label">发货时间</div>
            <div class="info-value">2025-03-18</div>
          </div>
          <div class="card-info">
            <div class="info-label">预计到达</div>
            <div class="info-value">2025-03-26</div>
          </div>
          <div class="card-info">
            <div class="info-label">当前状态</div>
            <div class="info-value">运输中</div>
          </div>

          <div class="divider"></div>

          <div class="timeline">
            <div class="timeline-item">
              <div class="timeline-time">2025-03-22 09:30</div>
              <div class="timeline-content">包裹已到达拉萨市物流中心</div>
            </div>
            <div class="timeline-item">
              <div class="timeline-time">2025-03-19 16:28</div>
              <div class="timeline-content">包裹已从成都市发出</div>
            </div>
            <div class="timeline-item">
              <div class="timeline-time">2025-03-18 11:15</div>
              <div class="timeline-content">订单已确认，设备正在准备中</div>
            </div>
          </div>
        </div>

        <!-- 历史设备物流记录 -->
        <div class="card">
          <div class="card-title">历史设备物流</div>

          <div class="card-box">
            <div class="card-box-title">
              <div>票据打印机</div>
              <div class="state">已完成</div>
            </div>
            <div class="info-text">
              订单编号: SB202501150924 | 2025-01-15
            </div>
            <div class="card-box-title">
              <div>票据打印机</div>
              <div class="state">已完成</div>
            </div>
            <div class="info-text">
              订单编号: SB202501150924 | 2025-01-15
            </div>

          </div>
        </div>
      </div>
      <!-- 耗材物流标签页内容 -->
      <div id="suppliesLogistics" v-else class="tab-content">
        <div class="card">
          <div class="order-summary">
            <div class="order-icon">📝</div>
            <div class="order-details">
              <div class="order-title">耗材物流跟踪</div>
              <div class="order-subtitle">订单编号: HC202503151056</div>
            </div>
          </div>

          <div class="card-info">
            <div class="info-label">耗材类型</div>
            <div class="info-value">热敏纸、色带、清洁套装</div>
          </div>
          <div class="card-info">
            <div class="info-label">发货时间</div>
            <div class="info-value">2025-03-15</div>
          </div>
          <div class="card-info">
            <div class="info-label">预计到达</div>
            <div class="info-value">2025-03-25</div>
          </div>
          <div class="card-info">
            <div class="info-label">当前状态</div>
            <div class="info-value">派送中</div>
          </div>

          <div class="divider"></div>

          <div class="timeline">
            <div class="timeline-item">
              <div class="timeline-time">2025-03-24 08:45</div>
              <div class="timeline-content">包裹已交由快递员配送，配送员：李师傅，联系电话：138****5678</div>
            </div>
            <div class="timeline-item">
              <div class="timeline-time">2025-03-23 19:30</div>
              <div class="timeline-content">包裹已到达拉萨市城关区配送中心</div>
            </div>
            <div class="timeline-item">
              <div class="timeline-time">2025-03-21 14:20</div>
              <div class="timeline-content">包裹已到达拉萨市物流中心</div>
            </div>
            <div class="timeline-item">
              <div class="timeline-time">2025-03-18 10:15</div>
              <div class="timeline-content">包裹已从成都市发出</div>
            </div>
            <div class="timeline-item">
              <div class="timeline-time">2025-03-15 16:30</div>
              <div class="timeline-content">订单已确认，耗材正在准备中</div>
            </div>
          </div>

          <div class="divider"></div>

          <div class="card-actions">
            <button class="btn btn-primary" @click="showToast('已通知快递员尽快送达')">联系配送员</button>
            <button class="btn btn-outline" @click="showToast('已申请签收延期')">延期签收</button>
          </div>
        </div>



        <!-- 历史耗材物流记录 -->
        <div class="card">
          <div class="card-title">历史耗材物流</div>
          <div class="card-box">
            <div class="card-box-title">
              <div>打印纸张</div>
              <div class="state">已完成</div>
            </div>
            <div class="info-text">
              订单编号: HC202502121422 | 2025-02-12
            </div>
            <div class="card-box-title">
              <div>清洁套装</div>
              <div class="state">已完成</div>
            </div>
            <div class="info-text">
              订单编号: HC202501051032 | 2025-01-05
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.content{
  padding-top: 120px;
  box-sizing: border-box;
}
</style>